exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.nav-tabs[data-v-0d19d5bd] {\r\n    margin-top: 0.625rem;\n}\n.listing-container[data-v-0d19d5bd] {\r\n    margin-bottom: 2.1875rem;\n}\n.cat-icon[data-v-0d19d5bd] {\r\n    width: 50px;\r\n    height: 50px;\n}\n.cat-icon img[data-v-0d19d5bd] {\r\n    max-width: 80%;\r\n    max-height: 80%;\n}\r\n", ""]);

// exports
